export enum MapTool {
  MeasureTool = 'measureTool',
  FeatureTool = 'featureTool',
  SearchTool = 'searchTool',
  None = 'none',
}
